import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import LogoTipImageSrc from './logo_tip_image.jpg';
const logoTipImageCss = "l1vmxx6u";
export const LogoTipImage = forwardRef((props, ref) => <img ref={ref} {...props} alt={I18n.t('publisher.account_settings.branding.logo_tip_image')} src={LogoTipImageSrc} className={classNames(logoTipImageCss, props.className)} />);

require("./logo_tip_image.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./logo_tip_image.js");